import ky from "ky-universal";

const getSplashData = async (source) => {
	const data = window[source] || {};
	let baseUrl = window.location.origin + data.apiUrl;
	let countryKeyJSON = data.countryKey ? JSON.stringify({ countryKey: data.countryKey }) : "";

	if (process.env.NODE_ENV !== "production") {
		countryKeyJSON = JSON.stringify({ countryKey: "5EDA63C7CB764D13BFFC44188EE331A5" });
		switch (source) {
			case "splashPageModal":
				baseUrl = "http://localhost:7000/audience-selector-api/get-splash-page-data-for-country";
				break;
			default:
				baseUrl = "http://localhost:7000/audience-selector-api/get-unknown-audience-location-data";
				break;
		}
	} else {
		baseUrl = window.location.origin + data.apiUrl;
	}

	const resData = await ky
		.post(baseUrl, {
			headers: new Headers({
				"Content-Type": "application/json"
			}),
			body: countryKeyJSON
		})
		.then((response) => {
			if (response.status === 200) {
				return response.json().then((data) => {
					if (Object.hasOwn(data, "status")) {
						if (data.status === "failed") {
							console.error(data);
							// { "status": "failed", "action": "none" }
							return {
								status: data.status,
								data: data
							};
						}
						if (data.action === "reload") {
							// { status: "success", action: "reload" }
							return {
								status: data.status,
								data: data.action
							};
						}
						return {
							status: "success",
							data: data
						};
					}
					return {
						status: "success",
						data: data
					};
				});
			} else {
				return {
					status: "failed",
					error: `${response.status}`
				};
			}
		})
		.then((res) => res)
		.catch((error) => {
			console.error(error);
			return {
				status: "failed",
				error: error
			};
		});
	return resData;
};
export default getSplashData;
